import { lazy } from 'react';
import { Route } from 'react-router';

import { FRONTEND_ROUTES } from '@/services/Constants';

const SignIn = lazy(() => import('../signIn/components/SignIn'));

const authRoutes = () => <Route path={FRONTEND_ROUTES.LOGIN} element={<SignIn />} />;

export default authRoutes;
